import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { I18nProvider } from "@lingui/react";
import { getCatalog, getDefaultLocale } from "../utils/i18n";
import { localeAddCatalog, localeSetLanguage } from "../actions";
import LuxonUtils from "@date-io/luxon";
import * as luxon from "luxon";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

class I18nLoader extends Component {
  state = {
    catalogs: {}
  };

  loadCatalog = async language => {
    const catalog = await getCatalog(language);
    this.props.addCatalog(language, catalog);
  };

  componentDidMount() {
    this.loadCatalog(this.props.language);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { language } = nextProps;
    const { catalogs } = nextState;

    if (language !== this.props.language && !catalogs[language]) {
      this.loadCatalog(language);
      return false;
    }

    return true;
  }

  render() {
    const { children, language, catalogs } = this.props;

    // Skip rendering when catalog isn't loaded.
    if (!catalogs[language]) return null;

    luxon.Settings.defaultLocale = language;

    return (
      <I18nProvider language={language} catalogs={catalogs}>
        <MuiPickersUtilsProvider
          utils={LuxonUtils}
          locale={language}
          libInstance={luxon}
        >
          {children}
        </MuiPickersUtilsProvider>
      </I18nProvider>
    );
  }
}

I18nLoader.propTypes = {
  addCatalog: PropTypes.func,
  catalogs: PropTypes.any,
  children: PropTypes.any,
  language: PropTypes.any
};

const mapStateToProps = state => ({
  language: state.locale.language || getDefaultLocale(),
  catalogs: state.locale.catalogs
});

const mapDispatchToProps = dispatch => ({
  setLanguage: language => dispatch(localeSetLanguage(language)),
  addCatalog: (locale, catalog) => dispatch(localeAddCatalog(locale, catalog))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(I18nLoader);
